import {
    ATTENDANCE_MENU_VIEW, TIMESHEET_MENU_VIEW, EXPENSES_MENU_VIEW,
    LEAVES_MENU_VIEW,
    USER_MAINTENANCE_MENU_VIEW,
    PAYSLIP_MENU_VIEW, MYTEAMS_MENU_VIEW, MYPROJECT_MENU_VIEW, CALENDAR_MENU_VIEW, DOCUMENT_APIDOC,
    MASTER_MENU_VIEW, SETTING_MENU_VIEW, REPORT_MENU_VIEW, TRAINING_MENU_VIEW, HELP_SUPPORT_MENU_VIEW, SUPPORT_AGENT_MENU_VIEW, SUPPORT_ADMIN_MENU_VIEW
} from '../config/permissions';

const Menu = [
    // { label: 'Home', icon: 'pi-home', url: '/home', active: true },
    { label: 'Dashboard', icon: 'pi-th-large', url: '/dashboard', active: true },
    { label: 'Timesheet', icon: 'pi-book', url: '/timesheets', permissions: [TIMESHEET_MENU_VIEW] },
    { label: 'My Project', icon: 'pi-briefcase', url: '/my-project', permissions: [MYPROJECT_MENU_VIEW] },
    { label: 'My Teams', icon: 'pi pi-users', url: '/team', permissions: [MYTEAMS_MENU_VIEW] },
    // { label: 'API Docs', icon: 'pi-book', url: '/documentations/api-doc', permissions: [DOCUMENT_APIDOC] },
    { label: 'Attendance', icon: 'pi-chart-line', url: '/attendance', permissions: [ATTENDANCE_MENU_VIEW] },
    { label: 'Expenses', icon: 'pi-dollar', url: '/expenses', permissions: [EXPENSES_MENU_VIEW] },
    { label: 'Leaves', icon: 'pi-verified', url: '/leaves', permissions: [LEAVES_MENU_VIEW] },
    { label: 'Travel', icon: 'pi pi-globe', url: '/Travel', permissions: " " },
    { label: 'Training', icon: 'pi pi-desktop', url: '/Training', permissions: [TRAINING_MENU_VIEW] },
    { label: 'Calendar', icon: 'pi-calendar', url: '/calendar', permissions: [CALENDAR_MENU_VIEW] },
    { label: 'Master', icon: 'pi-wrench', url: '/master', permissions: [MASTER_MENU_VIEW] },
    { label: 'Payslip', icon: 'pi-map', url: '/payslip', permissions: [PAYSLIP_MENU_VIEW] },
    { label: 'Reports', icon: 'pi-megaphone', url: '/reports', permissions: [REPORT_MENU_VIEW] },
    { label: 'Settings', icon: 'pi-cog', url: '/settings', permissions: [SETTING_MENU_VIEW] },
    { label: 'User', icon: 'pi-users', url: '/user-maintenance', permissions: [USER_MAINTENANCE_MENU_VIEW] },
    { label: 'Help & Support', icon: 'pi-headphones', url: '/support', permissions: [HELP_SUPPORT_MENU_VIEW] },
    { label: 'Support Agent', icon: 'pi-phone', url: '/support-queue', permissions: [SUPPORT_AGENT_MENU_VIEW] },
    { label: 'Support Admin', icon: 'pi-megaphone', url: '/support-admin', permissions: [SUPPORT_ADMIN_MENU_VIEW] },
    
    // { label: 'Help', icon: 'pi-info-circle', url: '/help' },
    // { label: 'Help Desk', icon: 'pi-question-circle', url: '/help-desk' },
    // { label: 'Help & Support', icon: 'pi-headphones', url: '/support' },
    // { label: 'Support Agent', icon: 'pi-phone', url: '/support-queue' },
    // { label: 'Support Admin', icon: 'pi-megaphone', url: '/support-admin' },


];

export default Menu;